import { t } from '@lingui/macro';
import { LoadingScreen } from 'noddi-ui-web';

export const NoddiLoadingScreenWithTrans = () => <LoadingScreen loadingText={t`Loading`} />;

export const NoddiLoadingScreenUpdateBooking = () => <LoadingScreen loadingText={t`Updating your booking`} />;
